var map = {
	"./adventura.json": 800,
	"./afternoondelight.json": 801,
	"./agave.json": 802,
	"./ahmos.json": 803,
	"./alicelloyd.json": 804,
	"./allenrumseysupperclub.json": 805,
	"./alleybar.json": 806,
	"./alumnifield.json": 807,
	"./amabistro.json": 808,
	"./amers.json": 809,
	"./angellhall.json": 810,
	"./angelos.json": 811,
	"./arb.json": 812,
	"./arborbrewingcompany.json": 813,
	"./ark.json": 814,
	"./ashleys.json": 815,
	"./aum.json": 816,
	"./autbar.json": 817,
	"./avalon.json": 818,
	"./baits.json": 819,
	"./bandemerpark.json": 820,
	"./banditos.json": 821,
	"./barlouie.json": 822,
	"./barrecode.json": 823,
	"./bdsmongoliangrill.json": 824,
	"./bellydeli.json": 825,
	"./benandjerrys.json": 826,
	"./betsybarbour.json": 827,
	"./bivouac.json": 828,
	"./blackpearl.json": 829,
	"./blankslate.json": 830,
	"./blimpyburger.json": 831,
	"./blindpig.json": 832,
	"./bluelep.json": 833,
	"./bluenile.json": 834,
	"./bluetractor.json": 835,
	"./brownjug.json": 836,
	"./buffalowildwings.json": 837,
	"./bursley.json": 838,
	"./burtontower.json": 839,
	"./cafefelix.json": 840,
	"./cafezola.json": 841,
	"./canhamnatatorium.json": 842,
	"./cardamom.json": 843,
	"./cclittlebuilding.json": 844,
	"./ccrb.json": 845,
	"./charleys.json": 846,
	"./chemistrybuilding.json": 847,
	"./chinagate.json": 848,
	"./chophouse.json": 849,
	"./chrysler.json": 850,
	"./clementslibrary.json": 851,
	"./cliffkeen.json": 852,
	"./cometcoffee.json": 853,
	"./commoncup.json": 854,
	"./conoroneills.json": 855,
	"./cottageinntakeout.json": 856,
	"./couzens.json": 857,
	"./crislercenter.json": 858,
	"./cupcakestation.json": 859,
	"./danabuilding.json": 860,
	"./dentalbuilding.json": 861,
	"./diag.json": 862,
	"./dolcevita.json": 863,
	"./dominicks.json": 864,
	"./dowbuilding.json": 865,
	"./duderstadt.json": 866,
	"./earle.json": 867,
	"./earthenjar.json": 868,
	"./easthall.json": 869,
	"./eastquad.json": 870,
	"./eecsbuilding.json": 871,
	"./elbelfield.json": 872,
	"./elixirVitae.json": 873,
	"./elixirvitae.json": 874,
	"./espressoroyalesouthu.json": 875,
	"./espressoroyalestate.json": 876,
	"./ferryfield.json": 877,
	"./fleetwooddiner.json": 878,
	"./fletcherhall.json": 879,
	"./fritabatidos.json": 880,
	"./fxb.json": 881,
	"./gandydancer.json": 882,
	"./ggbrown.json": 883,
	"./grange.json": 884,
	"./gratzi.json": 885,
	"./grizzlypeak.json": 886,
	"./hatcher.json": 887,
	"./heidelberg.json": 888,
	"./helennewberry.json": 889,
	"./hendersonhouse.json": 890,
	"./hillauditorium.json": 891,
	"./hopcat.json": 892,
	"./hunterhouse.json": 893,
	"./imbuilding.json": 894,
	"./insomnia.json": 895,
	"./iorios.json": 896,
	"./isalita.json": 897,
	"./jamaicanjerkpit.json": 898,
	"./jerusalemgarden.json": 899,
	"./jollypumpkin.json": 900,
	"./kilwins.json": 901,
	"./knights.json": 902,
	"./lab.json": 903,
	"./lawquad.json": 904,
	"./lawschool.json": 905,
	"./league.json": 906,
	"./literaticoffee.json": 907,
	"./livebar.json": 908,
	"./logan.json": 909,
	"./lunchroom.json": 910,
	"./maniosteria.json": 911,
	"./markley.json": 912,
	"./marneethai.json": 913,
	"./marthacook.json": 914,
	"./mash.json": 915,
	"./masonhall.json": 916,
	"./mden.json": 917,
	"./melange.json": 918,
	"./michigandaily.json": 919,
	"./michiganstadium.json": 920,
	"./michigantheater.json": 921,
	"./michiganunion.json": 922,
	"./mightygoodcoffee.json": 923,
	"./mitchellfield.json": 924,
	"./mlb.json": 925,
	"./mojo.json": 926,
	"./munger.json": 927,
	"./musicschool.json": 928,
	"./nagomisushi.json": 929,
	"./ncrb.json": 930,
	"./necto.json": 931,
	"./neopapalis.json": 932,
	"./northquad.json": 933,
	"./northwood3.json": 934,
	"./nothai4thave.json": 935,
	"./nothaisouthu.json": 936,
	"./oldtowntavern.json": 937,
	"./originalcottageinn.json": 938,
	"./oxford.json": 939,
	"./pacificrim.json": 940,
	"./palio.json": 941,
	"./palmercommons.json": 942,
	"./palmerfield.json": 943,
	"./pancheros.json": 944,
	"./phyllisockerfield.json": 945,
	"./pieology.json": 946,
	"./pierpont.json": 947,
	"./pitakabob.json": 948,
	"./pizzabobs.json": 949,
	"./pizzahouse.json": 950,
	"./powercenter.json": 951,
	"./pretzelbell.json": 952,
	"./pricklypear.json": 953,
	"./quickieburger.json": 954,
	"./rackham.json": 955,
	"./ragstock.json": 956,
	"./ravensclub.json": 957,
	"./rayfisherstadium.json": 958,
	"./realseafoodcompany.json": 959,
	"./redhawk.json": 960,
	"./ricks.json": 961,
	"./roosroast.json": 962,
	"./ross.json": 963,
	"./ruthschris.json": 964,
	"./sadako.json": 965,
	"./saladsup.json": 966,
	"./savas.json": 967,
	"./schoolofeducation.json": 968,
	"./schoolofsocialwork.json": 969,
	"./shalimar.json": 970,
	"./silvios.json": 971,
	"./skeeps.json": 972,
	"./slurpingturtle.json": 973,
	"./soccerstadium.json": 974,
	"./southquad.json": 975,
	"./spencer.json": 976,
	"./stamps.json": 977,
	"./starbucksmain.json": 978,
	"./starbuckssouthu.json": 979,
	"./starbucksstate.json": 980,
	"./statetheater.json": 981,
	"./stockwell.json": 982,
	"./stucchis.json": 983,
	"./sweeting.json": 984,
	"./sweetwatersliberty.json": 985,
	"./sweetwaterswashington.json": 986,
	"./tios.json": 987,
	"./tkwu.json": 988,
	"./tomukun.json": 989,
	"./totoro.json": 990,
	"./tropicalsmoothie.json": 991,
	"./ugli.json": 992,
	"./umgolfcourse.json": 993,
	"./umindoortrack.json": 994,
	"./umma.json": 995,
	"./urbanoutfitters.json": 996,
	"./varsitytenniscenter.json": 997,
	"./vinbar.json": 998,
	"./vinology.json": 999,
	"./washtenawdairy.json": 1000,
	"./weiserhall.json": 1001,
	"./westquad.json": 1002,
	"./yosticearena.json": 1003,
	"./zingermans.json": 1004
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 136;



//////////////////
// WEBPACK FOOTER
// ./src/json ^\.\/.*\.json$
// module id = 136
// module chunks = 0